import React from "react";
import "./App.css";
import "toastr/build/toastr.min.css";
import { ClipLoader } from "react-spinners";
import Card from "./components/Card/Card";
import FloatingButton from "./components/FloatingButton/FloatingButton";
import Grid from "./components/Grid/Grid";
import useQuestion from "./hooks/useQuestion";
import { QuestionProvider } from "./contexts/QuestionContext";

const App: React.FC = () => {
  const { loading } = useQuestion();

  return (
    <div className="app">
      <div className="container">
        {loading ? (
          <div
            className="spinner-container-style"
            data-testid="spinner-container"
          >
            <ClipLoader color="#36D7B7" loading={loading} size={80} />
          </div>
        ) : (
          <>
            <FloatingButton />
            <Card />
            <Grid />
          </>
        )}
      </div>
    </div>
  );
};

const AppWithQuestionProvider = () => (
  <QuestionProvider>
    <App />
  </QuestionProvider>
);

export default AppWithQuestionProvider;
